import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { immigrateQuestionEditData } from './slice'
import { immigrateQuestionAPI } from 'features/immigrate-question/api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    const requestParams = RequestUtils.getMapRequestParams(params)

    const response = yield call(immigrateQuestionAPI.getQuestion, id, requestParams)

    const { data } = response

    yield put(immigrateQuestionEditData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(immigrateQuestionEditData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeLatest(immigrateQuestionEditData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
